<template>
  <div class="plantRobot">
    <div v-if="formData && formData.length>0" class="wrap">
      <el-card shadow="never">
        <div slot="header">
          <span class="title">场站设备</span>
          <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
        </div>
        <div class="content">
          <div v-for="item in formData" :key="item.id" class="card" style="box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)" @click="getDetail(item)">
            <div class="left">
              <!-- <img :src="item.pic" alt="" /> -->
              <img v-if="item.pic==1" src="../../assets/robot1.png" alt="">
              <img v-else-if="item.pic==3" src="../../assets/robot3.png" alt="">
              <img v-else-if="item.pic==4" src="../../assets/robot4.png" alt="">
              <img v-else-if="item.pic==5" src="../../assets/robot5.png" alt="">
              <img v-else-if="item.pic==6" src="../../assets/robot6.png" alt="">
              <img v-else-if="item.pic==7" src="../../assets/robot7.png" alt="">
              <span>{{ item.deviceType }}</span>
            </div>
            <div class="right">
              <p>
                <span>设备编号</span>
                <span>{{ item.deviceNum }}</span>
              </p>
              <p>
                <span>设备名称</span>
                <span>{{ item.deviceName }}</span>
              </p>
              <p>
                <span>状态</span>
                <span>{{ item.deviceStatus }}</span>
              </p>
            </div>
          </div>

        </div>
      </el-card>
      <el-card shadow="never">
        <div slot="header">
          <span class="title">设备信息</span>
        </div>
        <div class="content2">
          <div class="row">
            <div class="box">
              <span>上送时间</span>
              <span>{{ otherData.time }}</span>
            </div>
          </div>
          <div class="row">
            <template v-for="(value,key,index) in otherData">
              <div v-if="key!='_id' && key!='time'" :key="index" class="box">
                <span v-if="key==='设备编号'">{{ deviceType }}编号</span>
                <span v-else>{{ key }}</span>
                <span>{{ value }}</span>
              </div>
            </template>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      formData: [],
      deviceType: '',
      otherData: {}
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.$store.dispatch('form/handle', {
      url: '/alarm/peripheral/selectPeripheralByStation?stationId=' + this.id,
      method: 'get',
      callback: (resp) => {
        if (resp && resp.length > 0) {
          this.formData = resp
          this.formData.forEach((item, i) => {
            switch (item.deviceType) {
              case '变压器':
                item.pic = 1
                break
              case '逆变器':
                item.pic = 3
                break
              case '储能系统':
                item.pic = 4
                break
              case '换电系统':
                item.pic = 5
                break
              case '照明系统':
                item.pic = 6
                break
              case '视频监控':
                item.pic = 7
                break
              default:
                break
            }
          })
          this.getDetail(this.formData[0])
        } else {
          this.$notify({
            title: '提示',
            message: '暂无周边设备',
            type: 'warning',
            duration: 1500
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500)
        }
      }
    })
  },
  methods: {
    getDetail(item) {
      this.deviceType = item.deviceType
      const data = {
        gateWayNo: item.gateWayNum,
        deviceNo: item.deviceNum
      }
      // const data = {
      //   gateWayNo: 281474976842034,
      //   deviceNo: 1
      // }
      this.$store.dispatch('form/handle', {
        url: '/logs/logs/getDeviceLog',
        data: data,
        method: 'get',
        callback: (resp) => {
          if (resp) {
            this.otherData = resp
          }
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
.plantRobot {
  .content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .card {
      width: calc(22% - 20px);
      height: 100px;
      box-sizing: border-box;
      border: 1px solid rgba(121, 121, 121, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 3%;
      margin-bottom: 20px;
      padding:10px;
      .left {
          width:80px;
          text-align: center;
        img {
          width: 55px;
          height: 55px;
          margin:0 auto 5px;
          display: block;
        }
        span {
          display: block;
        }
      }
      .right {
        width: calc(100% - 100px);
        p {
          display: flex;
          margin:5px 0;
          span {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:nth-of-type(1) {
              width: 60px;
              text-align: right;
            }
            &:nth-of-type(2) {
              font-size: 14px;
              color: #666666;
              padding-left: 10px;
            }
          }
        }
      }
    }
  }
  .content2{
      .row{
          display: flex;
          width: 95%;
          justify-content: space-between;
          flex-flow: wrap;
        .box{
            display: flex;
            height: 40px;
            width:30%;
            align-items: center;
			margin-top:20px;
            span{
                display: block;
                &:first-child{
                    width: 120px;
                    text-align: right;
                    margin-right: 50px;
                }
            }
        }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/plantRobot.vue